import { getAAId, invokeZCBot, isMobile } from "./common";
import config, { USER_TYPE, ACTIVITY_NO_PERMISSION_ST_STATUS_LABEL, ACTIVITY_NO_PERMISSION_STATUS_VALUE } from "Utils/constant";
import { logOperation } from "./operationLogUtils";
import { getSelectedSTObj } from "./addressUtils";
import React from "react";
export const getRules = (productRule: {
  id: number;
  maxQuantity?: number;
  maxAmount?: number;
  minQuantity?: number;
  minAmount?: number;
  minItem?: number;
  maxItem?: number;
  activityId: number;
  type: string;
}, options?: {
  tab?: string;
}): string[] => {
  if (!productRule) return [];
  let msg = "";
  const limitItems = [];
  const { maxQuantity, maxAmount, minQuantity, minAmount, minItem, maxItem } =
    productRule;
  if (minQuantity && maxQuantity) {
    let limitItem = `至少购买${minQuantity}件，最多购买${maxQuantity}件`;
    if (minQuantity === maxQuantity) {
      if (options?.tab === "exchange") {
        limitItem = `${maxQuantity}件`;
      } else {
        limitItem = `限定${maxQuantity}件`;
      }
    }
    
    limitItems.push(limitItem);
  } else {
    if (minQuantity) {
      const limitItem = `至少购买${minQuantity}件`;
      limitItems.push(limitItem);
    }
    if (maxQuantity) {
      const limitItem = `限购${maxQuantity}件`;
      limitItems.push(limitItem);
    }
  }
  if (minAmount && maxAmount) {
    const pre = !!msg;
    pre && (msg += "；");
    msg += `至少购买${minAmount}元，限购${maxAmount}元`;
    let limitItem = "";
    limitItem = `至少购买${minAmount}元，限购${maxAmount}元`;
    limitItems.push(limitItem);
  } else {
    if (minAmount) {
      const pre = !!msg;
      pre && (msg += "；");
      msg += `至少购买${minAmount}元`;
      const ms = `至少购买${minAmount}元`;
      limitItems.push(ms);
    }
    if (maxAmount) {
      const pre = !!msg;
      pre && (msg += "；");
      msg += `限购${maxAmount}元`;
      const ms = `限购${maxAmount}元`;
      limitItems.push(ms);
    }
  }
  if (minItem && maxItem) {
    const pre = !!msg;
    pre && (msg += "；");
    msg += `至少购买${minItem}种商品，限购${maxItem}种商品`;
    const ms = `至少购买${minItem}种商品，限购${maxItem}种商品`;
    limitItems.push(ms);
  } else {
    if (minItem) {
      const pre = !!msg;
      pre && (msg += "；");
      msg += `至少购买${minItem}种商品`;
      const ms = `至少购买${minItem}种商品`;
      limitItems.push(ms);
    }
    if (maxItem) {
      const pre = !!msg;
      pre && (msg += "；");
      msg += `限购${maxItem}种商品`;
      const ms = `限购${maxItem}种商品`;
      limitItems.push(ms);
    }
  }
  return limitItems;
};

export const getRuleType = (groupItem: any, groups: any): string => {
  const { categoryType, categoryName, categoryTypeValue } =
    groupItem.productRule;
  if (categoryType === "specify_category") return categoryName;
  if (categoryType === "any_num_categories")
    return `任意${categoryTypeValue}类`;
  if (groups.length <= 1) return "";
  return "其他分类";
};

export const getRuleTypeName = (groupItem: any): string => {
  const { categoryType, categoryName, categoryTypeValue } = groupItem;
  if (categoryType === "specify_category") return categoryName;
  if (categoryType === "any_num_categories")
    return `任意${categoryTypeValue}类`;
  return "其他分类";
};

export const getAllCartItemIds = (cartData: any, cartItemType?: string) => {
  const ids: any = [];
  const activityData = cartData.activity;
  const exchangeData = cartData.exchange;
  if (cartItemType === "bundle_promotion") {
    activityData?.productGroup?.forEach((group: any) => {
      ids.push(group.tieredRule.id);
    });
    return ids;
  }
  if (activityData) {
    const productGroup = activityData.productGroup;
    productGroup?.forEach((group: any) => {
      group.cartItems?.forEach((item: any) => {
        ids.push(item.id);
      });
    });
  }
  if (exchangeData) {
    const productGroup = exchangeData.productGroup;
    productGroup?.forEach((group: any) => {
      group.cartItems?.forEach((item: any) => {
        ids.push(item.id);
      });
    });
  }
  return ids;
};
export const getCartItemIds = (data: any) => {
  const ids: any = [];
  let noSpecifiedCatData = false;
  if (data) {
    const productGroup = data.productGroup;
    productGroup?.forEach((group: any) => {
      if (group.productRule.categoryType === "specify_category") {
        if (group.cartItems.length <= 0) {
          noSpecifiedCatData = true;
        }
      }
      group.cartItems?.forEach((item: any) => {
        ids.push(item.id);
      });
    });
  }
  return { ids, noSpecifiedCatData };
};

export const getBundleCartItemIds = (
  bundleIds: any,
  cartData: any,
  checkCache?: boolean
) => {
  const ids: any = [];
  console.log("cart request bundleIds", bundleIds);
  if (!bundleIds || !bundleIds.length) return ids;
  const activityData = cartData.activity;
  if (activityData) {
    const productGroup = activityData.productGroup;
    bundleIds?.forEach((bundleId: any, index: number) => {
      const group = productGroup.find(
        (group: any) => group.tieredRule.id === bundleId
      );
      console.log("index bundleId", bundleId);
      if (group) {
        group.cartItems?.forEach((item: any) => {
          ids.push(item.id);
        });
      } else {
        const win: any = window;
        const cachedCartIds = win.DPCache?.checkedCartIds;
        if (checkCache && cachedCartIds) {
          console.log("cachedCartIds", cachedCartIds);
          const cachedIds = cachedCartIds[bundleId];
          console.log("cachedIds", cachedIds);
          if (cachedIds) {
            ids.push(...cachedIds);
          }
        }
      }
    });
  }

  return ids;
};

export const hasNonOrderableCartItems = (
  checkedCartItems: any,
  cartData: any
) => {
  checkedCartItems.some((item: any) => {
    const activityData = cartData.activity;
    const exchangeData = cartData.exchange;
    const activityGroup = activityData?.productGroup;
    const exchangeGroup = exchangeData?.productGroup;
    let target:any = null
    activityGroup?.forEach((group: any) => {
      target = group.cartItems.find((cartItem: any) => cartItem.id === item);
    });
    if (target && target.priceStatus) return true;
    return false;
  });
  return false;
};

export const gotoPdp = async (
  product: any,
  loginState: any,
  pageHolder: string,
  isReturnBtn?: boolean,
  filtersParams?: any,
  activityId?: string,
) => {
  const result = await logOperation({
    opUser: loginState?.user?.user?.userId || getAAId(),
    opTarget: "Product_Detail",
    opTargetId: product.sku,
    opContent: pageHolder,
  });
  console.log("logOperation", result);
  if (!product.pdpViewable) return;
  const sku = product.sku;
  if (isMobile()) {
    const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
    if (isEmployee) return;

    const win = window as any;
    // Append source parameter for tracking; use pageHolder if provided else default label
    const source = encodeURIComponent("promotions");
    const baseUrl = `${config.APPLICATION_ENDPOINT}/product-details/pname/${sku}`;
    // Preserve existing query parameters if any future change adds them
    const separator = baseUrl.includes("?") ? "&" : "?";

    if (isReturnBtn && filtersParams) {
      let href = `${baseUrl}${separator}source=${source}&activityId=${product?.activityId || activityId}`;
      if (filtersParams !== 'null') {
        href = `${href}&filter=${encodeURIComponent(JSON.stringify(filtersParams))}`
      }
      win.location.href = href
    } else {
      win.location.href = `${config.APPLICATION_ENDPOINT}/product-details/pname/${sku}`;
    }
  } else {
    window.open(
      `https://www.thermofisher.cn/order/catalog/product/${sku}`,
      "_blank"
    );
  }
};

export const getFilteredCategories = (filteredMap: any, categoryList: any) => {
  const categories: string[] = [];
  const memoCat: string[] = [];
  if (filteredMap.size > 0) {
    filteredMap.forEach((value: any, key: any) => {
      if (typeof value === "string") {
        const target = categoryList.find((cat: any) => {
          return cat.categoryName === key;
        });
        console.log("target", target);
        target?.subCategoryList.forEach((subCat: any) => {
          if (subCat.id !== "all") {
            categories.push(`${key}#${subCat.categoryName}`);
          }
        });
        // if (target?.subCategoryList?.length === 1) {
        // }
        categories.push(`${key}#`);
        memoCat.push(`${key}`);
      } else {
        // value also is a map
        value.forEach((subValue: any, subKey: any) => {
          categories.push(`${key}#${subKey}`);
          memoCat.push(`${key}:${subKey}`);
        });
      }
    });
  }

  return {
    categories,
    memoCat,
  };
};
export const hasActivityStarted = (startTime: string) => {
  const now = new Date();
  console.log(now);
  const offsetMils = now.getTimezoneOffset() * 60 * 1000;
  const startTimeDate = new Date(startTime).getTime() + offsetMils;
  console.log(startTime, startTimeDate);
  const result = startTimeDate < now.getTime();
  console.log("hasActivityStarted", result);
  return result;
};

export const getTempFilterCatetory = (
  buzData: any,
  filteredCategories: any
) => {
  let tempFilteredMap = filteredCategories.filteredMap;
  for (let [key, value] of tempFilteredMap) {
    let found = false;
    if (buzData?.length > 0) {
      for (let item of buzData) {
        if (item.categoryName === key) {
          found = true;
          // 检查 value 中的 Map 对象
          if (value.size > 0) {
            for (let [innerKey, innerValue] of value) {
              let innerFound = false;
              for (let subItem of item.subCategoryList) {
                if (subItem.categoryName === innerKey) {
                  innerFound = true;
                  break;
                }
              }
              if (!innerFound) {
                value.delete(innerKey);
              }
            }
          }
          break;
        }
      }
      if (!found) {
        console.log("value", value);
        const matchingCategories = buzData.filter(
          (category: any) => category.categoryName === value
        );
        if (matchingCategories.length <= 0) {
          tempFilteredMap.delete(key);
        }
      }
    }
  }
  console.log("tempFilteredMap", tempFilteredMap);
  return tempFilteredMap;
};
export const handleContactUs = (loginState: any) => {
  const userInfo = loginState?.user?.user;
  invokeZCBot({
    payload: {
      empid: userInfo?.cdcUid || "",
      email: userInfo?.userName || "",
      firstName: userInfo?.firstName || "",
      lastName: userInfo?.lastName || "",
      gaCid: getAAId(),
      location: window.location.href,
      country: userInfo?.country || "cn",
      tel: userInfo?.contactInfo?.phone || "",
      company: userInfo
        ? getSelectedSTObj(loginState)?.companyOrInstitution
        : "",
    },
  });
};
/**
 *
 * @param respData
 * @param message
 * @param type {"common" | "quick" | "bundle"}
 * @param agent {"pc" | "mobile"}
 */
export const addToCartErrorHandle = (
  respData: any,
  message: any,
  type: string,
  agent: string
) => {
  switch (respData.status) {
    case "product_not_exist":
      if (!(type === "quick" && agent === "pc")) {
        message.warning("该货号不在活动范围内");
      }
      break;
    case "activity_not_launched":
      message.warning("活动未开始，暂时无法加入购物车");
      break;
    case "product_not_available":
      if (!(type === "quick" && agent === "pc")) {
        message.warning("该货号不可通过网络订购");
      }
      break;
    case "activity_not_found":
      message.warning("活动不存在，暂时无法加入购物车");
      break;
    case "activity_expired":
      message.warning("活动已过期，暂时无法加入购物车");
      break;
    case "inventory_not_enough":
      message.warning(
        React.createElement(
          "div",
          {
            style: {
              whiteSpace: "pre-line",
            },
          },
          respData.message || "该货号库存不足，暂时无法加入购物车"
        )
      );
      break;
    case "bundle_quantity_error":
      message.warning("加车失败，您已超过该组合加车数量限制");
      break;
    case ACTIVITY_NO_PERMISSION_STATUS_VALUE:
      message.warning("抱歉，当前账号及收货地址暂无法参与活动");
      break;
    default:
      const msg =
        type === "quick"
          ? "快速加车失败，请联系在线客服"
          : "加入购物车失败，可能是该产品不支持在线下单，如果问题持续，请联系在线客服";
      message.error(msg);
      break;
  }
};

export const submitOrderErrorHandle = (respData: any, message: any) => {
  switch (respData?.status) {
    case "inventory_not_enough":
      message.warning(
        React.createElement(
          "div",
          {
            style: {
              whiteSpace: "pre-line",
            },
          },
          respData.message
        )
      );
      break;
    case "cart_item_not_exists":
      message.warning("您的购物车产品信息发生变化，请重新选择产品下单");
      break;
    case "activity_expired":
      message.warning("提交订单失败，活动已过期！");
      break;
    case "activity_not_launched":
      message.warning("提交订单失败，活动未开始！");
      break;
    case "reached_max_order_limit":
      message.warning(
        `提交订单失败，您已超过此活动最大购买上限${respData.message}，请返回购物车页面重新选购产品！`
      );
      break;
    case "total_price_error":
      message.warning("提交订单失败，订单金额有误！");
      break;
    default:
      message.error("操作失败，请联系在线客服");
      break;
  }
};
export const getYourPriceLabel = (ops: {
  priceType?: string;
  isOrderPreviewFlag?: boolean;
  previewData?: any;
}) => {
  const { priceType, isOrderPreviewFlag, previewData } = ops;
  let yourPriceLabel = "";
  if (!isOrderPreviewFlag) return yourPriceLabel;
  if (previewData?.matchStatus) return yourPriceLabel;

  if (priceType === "yourPrice") {
    yourPriceLabel = "您的价格：";
  }
  if (priceType === "wop") {
    yourPriceLabel = "飞享价：";
  }
  if (priceType === "dpp" && previewData?.allowSingleItem) {
    yourPriceLabel = "促销价：";
  }
  return yourPriceLabel;
};

export const showListPriceLabel = (ops: {
  isOrderPreviewFlag?: boolean;
  previewData?: any;
}) => {
  const { previewData, isOrderPreviewFlag } = ops;
  let listPriceLabel = "";
  if (!isOrderPreviewFlag) return listPriceLabel;
  if (previewData?.matchStatus) return listPriceLabel;
  // if (previewData?.allowSingleItem) return listPriceLabel;

  listPriceLabel = "目录价：";

  return listPriceLabel;
};


export const hasSelected = (filteredMap: any, category: any, subCategory?:any) => {
  let selected = false;
  const targetCat = filteredMap.get(category.categoryName);
  if (targetCat) {
    if (typeof targetCat === "string") {
      selected = targetCat === "all";
    } else {
      const subCat = targetCat.get(subCategory.categoryName);
      selected = subCat;
    }
  }
  return selected;
};
